<template>
  <div class="grid grid-cols-2 gap-2 text-center">
    <div
      class="col-span-2 rounded-t-3xl! rounded-b-xl! buttonComponent font-bold! text-xl! bg-white/20!"
      :class="{ 'grayscale opacity-50 pointer-events-none': !isShortcutAvailable('recharges') }"
      @click="
        $bus.emit($constants.EVENTS.SERVICES.START, {
          group: 'recharges'
          // option: 'fund'
        })
      "
    >
      Retrait / Recharge
    </div>
    <div
      class="rounded-bl-3xl! rounded-xl! buttonComponent font-bold! text-xl! bg-white/20!"
      :class="{ 'grayscale opacity-50 pointer-events-none': !isShortcutAvailable('buy') }"
      @click="
        $bus.emit(
          $constants.EVENTS.SERVICES.START,
          {
            group: 'trade',
            option: 'buy'
          }
        )
      "
    >
      Achat
    </div>
    <div
      class="rounded-br-3xl! rounded-xl! buttonComponent font-bold! text-xl! bg-white/20!"
      :class="{ 'grayscale opacity-50 pointer-events-none': !isShortcutAvailable('sell') }"
      @click="
        $bus.emit(
          $constants.EVENTS.SERVICES.START,
          {
            group: 'trade',
            option: 'sell'
          }
        )
      "
    >
      Vente
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();
const { $stores } = proxy;

const isShortcutAvailable = (type) => {
  const countryCode = $stores.user.state.current?.countryCode;
  const appData = $stores.appData.state.data;
  const availability = appData?.serviceAvailability?.[countryCode];
  if (!availability) return true;

  if (type === 'recharges') {
    return (
      availability.fund1xBet ||
      availability.fundBetWinner ||
      availability.fund1Win ||
      availability.fundMelbet ||
      availability.fundEightStarz ||
      availability.withdrawal1xBet ||
      availability.withdrawalBetWinner ||
      availability.withdrawal1Win ||
      availability.withdrawalMelbet ||
      availability.withdrawalEightStarz
    );
  }
  if (type === 'buy') return availability.buyUsdt;
  if (type === 'sell') return availability.sellUsdt;

  return true;
};
</script>
